import React, { ComponentProps, ComponentType, JSXElementConstructor } from 'react';
import Text, { TextScale } from './Text';

type Props<TComponentType extends JSXElementConstructor<any>> =
  ComponentProps<TComponentType> & {
    as?: ComponentType;
    level?: 1 | 2;
  };

const Display = <TComponentType extends JSXElementConstructor<any>>(
  props: Props<TComponentType>
) => <Text {...props} scale={TextScale.Display} />;

export default Display;
